import { Container, Heading, Section } from 'react-bulma-components';

import React from 'react';
import resourceNotFound from "assets/images/404.jpg";

const NotFound = ({ message }) => {
return(
  <div>
    <Section>
        <Container>
          <p className="bd-notification is-success">
            <Heading size={5} renderAs="p">{message?message:"Nothing found"}</Heading>
            <Heading subtitle renderAs="p">Take a rest, and then try another resource.</Heading>
            <img
              src={resourceNotFound}
              style={{
                width: "35%",
                height: "auto",
                display: "block",
                margin: "auto",
                position: "relative"
              }}
            />
          </p>
        </Container>
      </Section>
    </div>
);
}
export default NotFound;